import { JSONSchema7 } from 'json-schema';
import { types as commonTypes } from '@sitebuilder/common';
import templateView from './DataProviderWebProfile';

const defaultQuery = `{
    children: webProfiles {
      id
    }
}`;

const schema: JSONSchema7 = {
    title: 'Data Provider Web Profile',
    type: 'object',
    required: [],
    properties: {},
};

const repeater: commonTypes.IWidget = {
    // without default
    schema,
    templateView,
    id: 'DataProviderWebProfile',
    group: 'data',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        classnames: '',
        expression: defaultQuery,
        exports: [],
    }),
};

export default repeater;
